/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import forOwn from 'lodash/forOwn';
import { Heading, toTitleCase } from 'sarsaparilla';

function NearbyActivities({ activities = {} }) {
    const renderActivities = [];
    forOwn(activities, (value, key) => {
        renderActivities.push(<li key={key}>{toTitleCase(value)}</li>);
    });

    if (renderActivities.length < 1) {
        return null;
    }

    return (
        <div className="rec-nearby-activities">
            <Heading headingLevel={3} appearance="h4" className="rec-section-header">
                Nearby Activities
            </Heading>
            <ul className="three">{renderActivities}</ul>
        </div>
    );
}

NearbyActivities.propTypes = {
    activities: PropTypes.object.isRequired,
};

export default NearbyActivities;
